<template>
  <bk-view class="giveMethod">
    <bk-view class="view-label">
      <span v-if="mustFlag" class="view-must">*</span>
      <bk-lang code="receiveGiftCard_method"></bk-lang>
    </bk-view>
    <bk-view class="view-tip">
      <bk-lang code="receiveGiftCard_methodTip"></bk-lang>
    </bk-view>
    <bk-view class="item-wrap">
      <bk-view class="view-item" v-for="(item) in options" :key="item.key" @click="handleClick(item.key)">
        <bk-view class="img-wrap" :class="{checked:item.checked }">
          <bk-view class="view-check" :class="{checked:item.checked }"></bk-view>
          <bk-image :src="item.src"/>
          <bk-lang :code="item.langCode"></bk-lang>
        </bk-view>
      </bk-view>
    </bk-view>
  </bk-view>
</template>

<script>

	export default {
		name: 'giveMethod',
		components: {},
		props: {
			dataList: Array,
			mustFlag: Boolean,
			value: {
				type: Array,
				default: () => {
					return []; // ['EMAIL','SMS','WHATS_APP']
				}
			},
			multiple: {
				type: Boolean,
				default: false
			}
		},
		data () {
			return {
				options: []
			};
		},
		computed: {},
		watch: {},
		methods: {
			handleClick (type) {
				if (!this.multiple) {
					this.options.forEach((item) => {
						item.checked = item.key === type;
					});
					let res = [type];
					this.$emit('update:value', res);
					return;
				}

				let res = [];
				this.options.forEach((item) => {
					if (item.key === type) {
						item.checked = !item.checked;
					}
					if (item.checked) {
						res.push(item.key);
					}
				});
				this.$emit('update:value', res);
			},
		},
		mounted () {
			this.options = this.$bk_copy(this.dataList);
			this.handleClick(this.dataList[0].key);
		}
	};
</script>

<style scoped lang="less">
@import './giveMethod.less';
</style>